import React, {useContext} from 'react';
import HeadingAndExpandableBody from '../UI/HeadingAndExpandableBody';
import {Context} from '../../context';
import Cards from '../Cards';

function BillingInformation(props) {
  const {localeText} = useContext(Context);

  return (
    <HeadingAndExpandableBody
      headingAndExpandableBodyId='billing-information'
      heading={localeText(
        'rw_header_billing_information',
        'Billing Information'
      )}
      expanded={props.expanded}
    >
      <Cards />
    </HeadingAndExpandableBody>
  );
}

export default BillingInformation;
